  // import React, { useEffect, useState } from 'react';
  // import axios from 'axios';
  // import {
  //   AreaChart,
  //   Area,
  //   XAxis,
  //   YAxis,
  //   CartesianGrid,
  //   Tooltip,
  //   ResponsiveContainer
  // } from 'recharts';

  // export default function DashboardPage() {
  //   const [stats, setStats] = useState(null);
  //   const [series, setSeries] = useState([]);

  //   const token = localStorage.getItem('token');
  //   const api = axios.create({
  //     baseURL: `${process.env.REACT_APP_API_URL}/api`,
  //     headers: { Authorization: `Bearer ${token}` },
  //   });

  //   useEffect(() => {
  //     async function load() {
  //       const [s, m] = await Promise.all([
  //         api.get('/stats/dashboard'),
  //         api.get('/stats/monthly?months=6'),
  //       ]);

  //       setStats(s.data);

  //       // Преобразуем данные для графика
  //       const map = new Map();
  //       m.data.revenue.forEach((r) => {
  //         const key = `${r._id.y}-${r._id.m}`;
  //         map.set(key, { month: key, income: r.total, expense: 0 });
  //       });
  //       m.data.expenses.forEach((e) => {
  //         const key = `${e._id.y}-${e._id.m}`;
  //         const row = map.get(key) || { month: key, income: 0, expense: 0 };
  //         row.expense = e.total;
  //         map.set(key, row);
  //       });

  //       // 🔹 Форматируем месяц
  //       const months = [
  //         'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
  //         'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
  //       ];

  //       const formatted = Array.from(map.values())
  //         .sort((a, b) => new Date(a.month) - new Date(b.month))
  //         .map((item) => {
  //           const [y, m] = item.month.split('-');
  //           return {
  //             ...item,
  //             month: `${months[m - 1]} ${y}`,
  //           };
  //         });

  //       setSeries(formatted);
  //     }

  //     load();
  //   }, []);

  //   // 💰 Форматирование чисел
  //   function formatMoney(value) {
  //     return new Intl.NumberFormat('ru-RU', {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     }).format(value);
  //   }

  //   if (!stats) return <div className="text-zinc-400">Загрузка...</div>;

  //   const profit = stats.profit;
  //   const profitColor = profit >= 0 ? 'text-emerald-400' : 'text-red-400';

  //   return (
  //     <div className="space-y-6">
  //       {/* 📊 Основные карточки */}
  //       <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
  //         <StatCard title="Машины" value={stats.carsCount} />
  //         <StatCard title="Клиенты" value={stats.customersCount} />
  //         <StatCard title="Активные аренды" value={stats.activeRentalsCount} />
  //         <StatCard
  //           title="Прибыль в месяц"
  //           value={`${formatMoney(profit)} `}
  //           color={profitColor}
  //         />
  //       </div>

  //       {/* 📈 График доходов и расходов */}
  //       <div className="bg-zinc-900 rounded p-4">
  //         <div className="text-lg mb-2 text-zinc-200">Доходы и расходы</div>
  //         <div className="h-64">
  //           <ResponsiveContainer width="100%" height="100%">
  //             <AreaChart data={series}>
  //               <defs>
  //                 <linearGradient id="income" x1="0" y1="0" x2="0" y2="1">
  //                   <stop offset="5%" stopColor="#22c55e" stopOpacity={0.8} />
  //                   <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
  //                 </linearGradient>
  //                 <linearGradient id="expense" x1="0" y1="0" x2="0" y2="1">
  //                   <stop offset="5%" stopColor="#ef4444" stopOpacity={0.8} />
  //                   <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
  //                 </linearGradient>
  //               </defs>
  //               <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
  //               <XAxis dataKey="month" stroke="#a1a1aa" />
  //               <YAxis stroke="#a1a1aa" />
  //               <Tooltip
  //                 formatter={(value, name) => [`${formatMoney(value)} `, name === 'income' ? 'Доход' : 'Расход']}
  //               />
  //               <Area
  //                 type="monotone"
  //                 dataKey="income"
  //                 stroke="#22c55e"
  //                 fillOpacity={1}
  //                 fill="url(#income)"
  //               />
  //               <Area
  //                 type="monotone"
  //                 dataKey="expense"
  //                 stroke="#ef4444"
  //                 fillOpacity={1}
  //                 fill="url(#expense)"
  //               />
  //             </AreaChart>
  //           </ResponsiveContainer>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  // function StatCard({ title, value, color = 'text-white' }) {
  //   return (
  //     <div className="bg-zinc-900 rounded p-4">
  //       <div className="text-sm text-zinc-400">{title}</div>
  //       <div className={`text-2xl font-semibold ${color}`}>{value}</div>
  //     </div>
  //   );
  // }



  import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [series, setSeries] = useState([]);

  const token = localStorage.getItem('token');
  const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
    headers: { Authorization: `Bearer ${token}` },
  });

  useEffect(() => {
    async function load() {
      const [s, m] = await Promise.all([
        api.get('/stats/dashboard'),
        api.get('/stats/monthly?months=6'),
      ]);

      setStats(s.data);

      const map = new Map();
      m.data.revenue.forEach((r) => {
        const key = `${r._id.y}-${r._id.m}`;
        map.set(key, { month: key, income: r.total, expense: 0 });
      });
      m.data.expenses.forEach((e) => {
        const key = `${e._id.y}-${e._id.m}`;
        const row = map.get(key) || { month: key, income: 0, expense: 0 };
        row.expense = e.total;
        map.set(key, row);
      });

      const months = [
        'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
        'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек',
      ];

      const formatted = Array.from(map.values())
        .sort((a, b) => new Date(a.month) - new Date(b.month))
        .map((item) => {
          const [y, m] = item.month.split('-');
          return { ...item, month: `${months[m - 1]} ${y}` };
        });

      setSeries(formatted);
    }

    load();
  }, []);

  function formatMoney(value) {
    return new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (!stats) return <div className="text-zinc-400">Загрузка...</div>;

  const profit = stats.profit;
  const profitColor = profit >= 0 ? 'text-emerald-400' : 'text-red-400';

  return (
    <div className="space-y-6">
      {/* 📊 Основные карточки */}
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
        <StatCard title="Машины" value={stats.carsCount} />
        <StatCard title="Клиенты" value={stats.customersCount} />
        <StatCard title="Активные аренды" value={stats.activeRentalsCount} />
        <StatCard
          title="Прибыль в месяц"
          value={`${formatMoney(profit)}`}
          color={profitColor}
        />
      </div>

      {/* 📈 График доходов и расходов */}
      <div className="bg-zinc-900 rounded-lg p-4 sm:p-5">
        <div className="text-lg sm:text-xl mb-3 text-zinc-200 text-center sm:text-left">
          Доходы и расходы
        </div>
        <div className="h-64 sm:h-72">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={series}>
              <defs>
                <linearGradient id="income" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#22c55e" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#22c55e" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="expense" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#ef4444" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
              <XAxis dataKey="month" stroke="#a1a1aa" />
              <YAxis stroke="#a1a1aa" />
              <Tooltip
                formatter={(value, name) => [
                  `${formatMoney(value)}`,
                  name === 'income' ? 'Доход' : 'Расход',
                ]}
              />
              <Area
                type="monotone"
                dataKey="income"
                stroke="#22c55e"
                fillOpacity={1}
                fill="url(#income)"
              />
              <Area
                type="monotone"
                dataKey="expense"
                stroke="#ef4444"
                fillOpacity={1}
                fill="url(#expense)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, value, color = 'text-white' }) {
  return (
    <div className="bg-zinc-900 rounded-lg p-3 sm:p-4 text-center sm:text-left">
      <div className="text-xs sm:text-sm text-zinc-400">{title}</div>
      <div className={`text-lg sm:text-2xl font-semibold ${color}`}>{value}</div>
    </div>
  );
}
